// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { IopReadingResponse } from './iop-reading-response';

// @ts-ignore
import { TargetIopResponse } from './target-iop-response';

/** See com.rev360.pms.api.controller.patient.ongoingcare.GlaucomaDataResponse */
/* istanbul ignore next */
@GandalfModel
export class GlaucomaDataResponse extends GandalfModelBase {

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	encounterDate!: Date;

	@GandalfProperty({ designType: Number })
	encounterId!: number;

	@GandalfArray(IopReadingResponse)
	iopReadings!: IopReadingResponse[];

	@GandalfProperty({ designType: Number })
	odHorizontalCd!: number | null;

	@GandalfProperty({ designType: Number })
	odVerticalCd!: number | null;

	@GandalfProperty({ designType: Number })
	osHorizontalCd!: number | null;

	@GandalfProperty({ designType: Number })
	osVerticalCd!: number | null;

	@GandalfProperty({ designType: Boolean })
	performed76514!: boolean;

	@GandalfProperty({ designType: Boolean })
	performed92020!: boolean;

	@GandalfProperty({ designType: Boolean })
	performed92083!: boolean;

	@GandalfProperty({ designType: Boolean })
	performed92132!: boolean;

	@GandalfProperty({ designType: Boolean })
	performed92134!: boolean;

	@GandalfProperty({ designType: Boolean })
	performed92135!: boolean;

	@GandalfProperty({ designType: Boolean })
	performed92250!: boolean;

	@GandalfProperty({ designType: Boolean })
	performed92275!: boolean;

	@GandalfProperty({ designType: Boolean })
	performed95930!: boolean;

	@GandalfArray(TargetIopResponse)
	targetIops!: TargetIopResponse[];

}
